module.exports = __webpack_public_path__ + "static/blog_placeholder-1df76830df78478c28bb14d8ca1f8fa2.png";